import { webApp } from '@myhrbox/myhrbox-frontend-core';

const cloudStorage = webApp?.CloudStorage;

const getItem = (key: string): Promise<string | undefined> =>
  new Promise((resolve, reject) => {
    cloudStorage?.getItem(key, (error, value) => {
      if (!error) {
        resolve(value);
      } else {
        reject(error);
      }
    });
  });

const setItem = (key: string, value: string) =>
  new Promise((resolve, reject) => {
    cloudStorage?.setItem(key, value, (error, state) => {
      if (!error && state) {
        resolve(state);
      } else {
        reject(error);
      }
    });
  });

const removeItem = (key: string) =>
  new Promise((resolve, reject) => {
    cloudStorage?.removeItem(key, (error, state) => {
      if (!error && state) {
        resolve(state);
      } else {
        reject(error);
      }
    });
  });

export { getItem, removeItem, setItem };
